import { alpha, colors, hexToRgbA } from './colors';

const blueTheme = {
  main: colors.blue,
  light: colors.lightBlue,
  lightest: colors.lightestBlue
};

const redTheme = {
  main: colors.red,
  light: colors.lightRed,
  lightest: colors.lightestRed
};

const orangeTheme = {
  main: colors.orange,
  light: colors.lightOrange,
  lightest: colors.lightestOrange
};

const greenTheme = {
  main: colors.green,
  light: colors.lightGreen,
  lightest: colors.lightestGreen
};

const purpleTheme = {
  main: colors.purple,
  light: colors.lightPurple,
  lightest: colors.lightestPurple
};

const pinkTheme = {
  main: colors.pink,
  light: colors.lightPink,
  lightest: colors.lightestPink
};

const rustTheme = {
  main: colors.rust,
  light: colors.lightRust,
  lightest: colors.lightestRust
};

const generateThemePalette = (themeColors) => ({
  primary: themeColors,
  background: {
    default: colors.white,
    primary: themeColors.lightest
  },

  border: {
    primary: themeColors.main,
    secondary: themeColors.light
  },

  shadow: {
    primary: hexToRgbA(colors.black, alpha.tenPercent),
    secondary: hexToRgbA(colors.black, alpha.twentyPercent)
  },

  font: {
    default: colors.darkGrey,
    invertedDefault: colors.white,
    primary: colors.darkGrey,
    secondary: colors.grey,
    tertiary: colors.blueGrey
  }
});

export const bluePalette = generateThemePalette(blueTheme);
export const redPalette = generateThemePalette(redTheme);
export const orangePalette = generateThemePalette(orangeTheme);
export const greenPalette = generateThemePalette(greenTheme);
export const purplePalette = generateThemePalette(purpleTheme);
export const pinkPalette = generateThemePalette(pinkTheme);
export const rustPalette = generateThemePalette(rustTheme);

const palettes = {
  blue: bluePalette,
  red: redPalette,
  orange: orangePalette,
  green: greenPalette,
  purple: purplePalette,
  pink: pinkPalette,
  rust: rustPalette
};

export default palettes;
